import React from "react";

import { Download, X } from "lucide-react";
import ModalV2 from "../../../../../shared/components/modalV2";
import {
  FEATURED_ICON,
  GREEN_CLOSE_BTN,
  PAPER_SLIP,
} from "../../../../../assets";

interface PaymentReceiptModalProps {
  open: boolean;
  close: () => void;
}

const PaymentReceiptModal: React.FC<PaymentReceiptModalProps> = ({
  open,
  close,
}) => {
  return (
    <ModalV2
      isOpen={open}
      isClose={close}
      maxWidth="w-[429px]"
      edges="rounded-2xl"
    >
      <div className="flex flex-col bg-white p-8 relative">
        {/* Close Button */}
        <button
          onClick={close}
          className="absolute top-3 right-6 p-1 rounded-full hover:bg-gray-100 transition-colors"
        >
          <img src={GREEN_CLOSE_BTN} className="w-[17px] h-[17px]" alt="" />
        </button>

        {/* Icon & Title */}
        <div className="flex flex-col items-center gap-y-4 mb-8">
          <div className=" flex items-center justify-center">
            <img src={PAPER_SLIP} alt="Receipt" className="w-[78px] h-[78px]" />
          </div>
          <h2 className="text-xl font-bold text-[#101828]">Payment Receipt</h2>
        </div>

        {/* Amount */}
        <div className="flex flex-col items-center gap-y-1 mb-8">
          <span className="text-sm text-[#475467] font-medium">Amount</span>
          <span className="text-4xl font-bold text-[#101828]">₦ 10,000</span>
        </div>

        {/* Details Card */}
        <div className="border border-[#E9EAEB] flex flex-col items-start w-full rounded-xl overflow-hidden mb-8">
          <div className="bg-white w-full flex items-start  px-6 py-4 border-b border-[#E9EAEB]">
            <span className="text-sm font-semibold text-[#101828]">
              Payment Details
            </span>
          </div>

          <div className="flex flex-col px-6 py-4 gap-y-4 w-full">
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-[#101828]">Date</span>
              <span className="text-sm font-semibold text-[#101828]">
                Oct 20, 2023
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-[#101828]">
                Depositor
              </span>
              <span className="text-sm font-semibold text-[#101828]">
                Emmanuel Ojo
              </span>
            </div>
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-[#101828]">
                Account name
              </span>
              <span className="text-sm font-semibold text-[#101828]">
                Susan Anyaogu
              </span>
            </div>
            <div className="flex items-center justify-between pb-4 border-b border-dashed border-[#E9EAEB]">
              <span className="text-sm font-medium text-[#101828]">
                Payment method
              </span>
              <span className="text-sm font-semibold text-[#101828]">
                Paystack
              </span>
            </div>

            <div className="pt-2 flex flex-col items-start w-full">
              <span className="text-xs font-medium text-[#475467] uppercase mb-4 block">
                ASSESSMENT DETAIL
              </span>

              <div className="flex flex-col gap-y-4 w-full">
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-[#101828]">
                    Attache fee
                  </span>
                  <span className="text-sm font-semibold text-[#101828]">
                    ₦5,000.00
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-[#101828]">
                    Filing
                  </span>
                  <span className="text-sm font-semibold text-[#101828]">
                    ₦5,000.00
                  </span>
                </div>
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-[#101828]">
                    Oath
                  </span>
                  <span className="text-sm font-semibold text-[#101828]">
                    ₦5,000.00
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Actions */}
        <div className="flex items-center gap-x-3">
          <button
            onClick={close}
            className="flex-1 py-2.5 border border-[#D0D5DD] rounded-lg text-sm font-semibold text-[#B03636] hover:bg-gray-50 transition-colors"
          >
            Cancel
          </button>
          <button className="flex-1 flex items-center justify-center gap-x-2 py-2.5 border border-[#00B074] rounded-lg text-sm font-semibold text-[#00B074] hover:bg-[#E6F7F1] transition-colors">
            <Download className="w-4 h-4" />
            Download Receipt
          </button>
        </div>
      </div>
    </ModalV2>
  );
};

export default PaymentReceiptModal;
